import { tsValidateString } from '@nu-art/ts-common';
import { knowledgeManagerDBGroup } from '@app/hcs-shared';
const Validator_ModifiableProps = {
    label: tsValidateString(),
};
const Validator_GeneratedProps = {};
export const DBDef_PertinentCategory = {
    modifiablePropsValidator: Validator_ModifiableProps,
    generatedPropsValidator: Validator_GeneratedProps,
    versions: ['1.0.0'],
    dbKey: 'pertinent-category',
    entityName: 'Pertinent Category',
    frontend: {
        group: knowledgeManagerDBGroup,
        name: 'pertinent-category'
    },
    backend: {
        name: 'pertinent-category'
    },
};
//# sourceMappingURL=db-def.js.map